import Cookies from 'js-cookie';

export default {
    data() {
        return {
            // Only used on nginx side for redirection of unlocalized links like https://www.acronis.com/products/.
            // Will be set on mounted if the locale is not default or explicitly clicked in the ribbon
            COOKIE_NAME_LANGUAGE_PREFIX: 'language_prefix',
            // Used for self-ID in the desired_locale mechanics.
            // Will ONLY be set with a user deliberate action.
            COOKIE_NAME_DESIRED_LOCALE: 'desired_locale',
            COOKIE_LOCALE_EXPIRATION: 30,
        };
    },

    computed: {
        locale() {
            return this.$store.state.geolocation.finalLocale || 'en-us';
        },
    },

    methods: {
        storeLanguagePrefix(locale) {
            if (!locale) return;

            Cookies.set(this.COOKIE_NAME_LANGUAGE_PREFIX, locale, {
                path: '/',
                expires: this.COOKIE_LOCALE_EXPIRATION,
            });
        },

        storeDesiredLocale(locale) {
            if (!locale) return;

            Cookies.set(this.COOKIE_NAME_DESIRED_LOCALE, locale, {
                path: '/',
                expires: this.COOKIE_LOCALE_EXPIRATION,
            });
        },
    },
};
